<template>
    <div class="small-basket">
        <div class="small-basket__front" @click="open = !open">
            <svg>
                <use xlink:href="#svg-basket"></use>
            </svg>
            <span class="small-basket__counter">
                <span v-if="items.length > 0">
                    {{ items.length }}
                </span>
            </span>
        </div>
        <transition name="fade">
            <div v-if="open" class="small-basket__block">
                <div class="small-basket__header">
                    <div class="small-basket__title">
                        <h5 v-if="messages && messages.title">{{ messages.title }}</h5>
                        <span v-if="items && items.length > 0" class="small-basket__number">
                            {{ items.length }}
                        </span>
                    </div>
                    <svg @click="open = false">
                        <use xlink:href="#svg-close"></use>
                    </svg>
                </div>
                <PerfectScrollbar v-if="items && items.length > 0" class="small-basket__items">
                    <SmallBasketItem v-for="item in items" :result="item"/>
                </PerfectScrollbar>
                <div class="small-basket__empty"
                     v-else-if="items && items.length == 0 && messages && messages.emptyBasket"
                >
                    {{ messages.emptyBasket }}
                </div>
                <div class="small-basket-bottom" v-if="items && items.length > 0">
                    <div>
                        <div
                            v-if="delivery && delivery.printPrice"
                            class="small-basket-bottom__row"
                        >
                            <span v-if="delivery && messages.deliveryTitle">
                                {{ messages.deliveryTitle }}
                            </span>
                            <span
                                v-if="delivery && delivery.printPrice"
                                class="small-basket-bottom__free"
                            >
                              {{ delivery.printPrice }}
                            </span>
                        </div>
                        <div
                            v-if="price && price.printPrice"
                            class="small-basket-bottom__row"
                        >
                            <span
                                v-if="messages && messages.total_amount"
                            >
                                {{messages.total_amount}}
                            </span>
                            <span
                                v-if="price && price.printPrice"
                                class="def-price"
                            >
                                {{ price.printPrice }}
                            </span>
                        </div>
                    </div>
                    <div class="small-basket-bottom__buttons">
                        <a :href="routes.basket.path" class="small-basket-bottom__basket">
                            {{routes.basket.name}}
                        </a>
                        <a :href="routes.createOrder.path" class="def-button">
                            {{routes.createOrder.name}}
                        </a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'SmallBasket',
    data() {
        return {
            open: false,
        }
    },
    computed: {
        ...mapState({
            items: ({ basket }) => basket?.data?.items,
            messages: ({ basket }) => basket?.data?.messages,
            delivery: ({ basket }) => basket?.data?.delivery,
            price: ({ basket }) => basket?.data?.price,
            routes: ({ basket }) => basket?.data?.routes,
        }),
    },
    methods: {
        /**
         *
         * **/
        getItem(id) {
            if (this.obdata && this.obdata.items && this.obdata.items.length) {
                let item = this.obdata.items.filter(item => item.id === id);
                if (item.length > 0) {
                    return item[0];
                }
            }
            return null;
        },
        getPrice() {
            return this.price;
        },
        handlerAnotherClick({target}) {
            if (!target.closest('.small-basket')) {
                this.open = false;
            }
        },
        async buyOneClick(productId,phone) {
            try {
                const { path, ['params-example-data']: { LANGUAGE_ID, action } } = this.obData?.routs?.buyOneClick;

                const params = {
                    action,
                    LANGUAGE_ID,
                    phone,
                    productId
                }

                const response  = await axios.post(path, params);
                const { data, status } = response;

                if (status === 200) {
                    await this.updateSmallBasket();
                }

                return response;
            } catch (err) {
                console.error(err);
            }
        },
        async updateSmallBasket() {
            try {
                const updateSmallBasket = this.obData?.routs?.updateSmallBasket;

                if (updateSmallBasket) {
                    const { path, ['params-example-data']: { LANGUAGE_ID, action } } = updateSmallBasket;

                    const params = {
                        action,
                        LANGUAGE_ID,
                    }

                    const response  = await axios.post(path, params);
                    const { data, status } = response;

                    if (status === 200) {
                        this.obData = {
                            ...data
                        }

                        this.eventChangeData();
                    }

                    return response;
                }

            } catch (err) {
                console.error(err);
            }
        }
    },
    watch: {
        open(prevValue) {
            if (prevValue) {
                document.addEventListener('click', this.handlerAnotherClick);
            } else {
                document.removeEventListener('click', this.handlerAnotherClick);
            }
        }
    },
}
</script>

<style lang="scss">
.small-basket {
    position: relative;

    &__front {
        display: flex;
        align-items: center;

        svg {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            @include point-md{
                width: 24px;
                height: 24px;
            }
        }

        &:hover {
            cursor: pointer;
        }
    }

    &__block {
        position: absolute;
        z-index: 3;
        right: 0;
        top: 100%;
        width: 300px;
        background-color: #fff;
        @include point-md{
            width: 350px;
        }
        @include point-lg{
            width: 464px;
        }
    }

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        padding: 0 8px;
        box-shadow: 0px 4px 5px rgba(47, 76, 120, 0.1);
        @include point-md{
            height: 68px;
            padding: 0 24px;
        }
        svg {
            width: 15px;
            height: 15px;
            fill: var(--text-colour-primary);
            @include point-md{
                width: 20px;
                height: 20px;
            }
            &:hover {
                cursor: pointer;
            }
        }
    }

    &__title {
        display: flex;
        font-weight: 500;
        font-size: rem(16);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--text-colour-primary);
        transform: translateY(2px);
        @include point-md{
            font-size: rem(20);
        }
        h5{
            transform: translateY(2px)
        }
    }

    &__number {
        display: flex;
        align-items: center;
        font-size: rem(18);
        margin-left: 5px;
    }

    &__items {
        padding: 8px 8px 0;
        background-color: #F7F8F9;
        max-height: 676px;
        overflow-y: auto;
        background-image: url('/local/templates/love-you/images/small-basket/empty_cart.png');
        background-position: center;
        @include point-md{
            padding: 16px 24px 0;
        }
    }

    &__counter {
        width: 10px;
    }

    &__empty{
        padding: 13px 26px;
    }
}

.small-basket-bottom {
    padding: 16px 8px;
    font-weight: 500;
    font-size: rem(16);
    color: var(--text-colour-primary);
    box-shadow: 0px -4px 5px rgba(223, 223, 223, 0.2);
    position: relative;
    @include point-md{
        padding: 24px;
    }
    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    &__basket {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        background: #B8D9EC;
        padding: 0 10px;
        width: 100%;
        color: var(--text-colour-secondary);
        margin-bottom: 14px;
        @include point-lg{
            margin-bottom: 0;
            margin-right: 8px;
            max-width: 179px;
            height: 48px;
        }
    }

    &__buttons {
        display: flex;
        flex-direction: column;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-size: rem(14);
        @include point-lg{
            flex-direction: row;
            align-items: center;
        }
    }

    &__free {
        color: var(--text-colour-secondary);
    }

    .def-button {
        color: #fff;
        flex-grow: 1;
        height: 40px;
        @include point-lg{
            height: 48px;
        }
    }
}
</style>